import { render } from "./ClientCallSquadDetail.vue?vue&type=template&id=589fa40f"
import script from "./ClientCallSquadDetail.vue?vue&type=script&lang=js"
export * from "./ClientCallSquadDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__